import { BuildSettings } from '@bcf-shared-settings/settings/types';

export const buildSettings: BuildSettings = {
  isDevServer: false,
  environment: 'prod'
};
